import checkLandBasic from "../basicRule/checkLandBasic";
import checkLimitList from "../basicRule/checkLimitList";

/**
 * 檢查說明: 檢查"現存資料"欄位
 * */
const checkLandSource = (cell, worksheet, checkList) => {
  let tmpStr = "";

  tmpStr = checkLandBasic(cell, worksheet);

  if (!tmpStr) {
    tmpStr = checkLimitList(cell, worksheet, checkList);
  }

  return tmpStr;
};

export default checkLandSource;
